export default "__VITE_PUBLIC_ASSET__86feb69f__"